<script setup lang="ts">
import type { NovaBoxPostsSimpleItemProps } from './NovaBoxPostsSimpleItem.types'

defineProps<NovaBoxPostsSimpleItemProps>()
</script>

<template>
  <div type="button" class="simple-post-item">
    <div class="image-wrap">
      <NovaImageContainer
        :image-url="post.thumbUrl || ''"
        :ratio="'1:1'"
        :empty-type="'default'"
      />
    </div>

    <div class="contents">
      <p v-if="post.nttSj" v-dompurify-html="post.nttSj" class="post-title" />
      <p class="user-name">{{ post.userNcnm }}</p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.simple-post-item {
  display: flex;
  align-items: center;
  gap: 14px;
  cursor: pointer;

  .image-wrap {
    flex-shrink: 0;
    width: 58px;
    height: 58px;
    border-radius: 4px;
    overflow: hidden;
    border: 1px solid $color-border-1;
  }

  .contents {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    gap: 10px;

    > .post-title {
      @include text-style($text-body-14-medium);
      @include ellipsis(2);
      line-height: 16px;
      color: $color-text-2;
    }

    > .user-name {
      @include text-style($text-body-12-regular);
      @include ellipsis(1);
      line-height: 16px;
      color: $color-text-3;
    }
  }
}
</style>
